import React from 'react';
import PropTypes from 'prop-types';

import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import RichText from 'dpl/prismic/components/RichText';

export default function MagazineAboutCallout({ sliceData }) {
  return (
    <div className="PrismicMagazineAboutCallout container tl tc-l">
      <div className="pv12 pv20-lg bt bb b--black">
        <h3 className="mb4 mb8-lg purple f4 f6-md lh-title">
          {sliceData.primary.headline}
        </h3>
        {sliceData.primary.content && (
          <div className="row f5 fw-medium">
            <div className="col-lg-9 col-xl-8 center f4-lg">
              <RichText content={sliceData.primary.content} />
            </div>
          </div>
        )}
        {sliceData.primary.callout_text && sliceData.primary.callout_link && (
          <div className="mt7">
            <a
              className="pv3 ph6 button button--primary fw-medium d-block d-lg-inline-block"
              href={sliceData.primary.callout_link.url}
              target={sliceData.primary.callout_link.target}
            >
              {sliceData.primary.callout_text}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

MagazineAboutCallout.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      content: StructuredTextPropTypes,
      headline: PropTypes.string,
      callout_link: PropTypes.shape({
        target: PropTypes.string,
        url: PropTypes.string
      }),
      callout_text: PropTypes.string
    }).isRequired,
    content: PropTypes.arrayOf(StructuredTextPropTypes),
    headline: PropTypes.string
  }).isRequired
};
